import React from 'react'
import { Button } from 'antd'
import {
  EOrderStatus,
  ERecieveMethod,
  ITableOrder,
  TPickupPointProvider
} from 'models/orders'
import styles from './ChangeShipmentPoint.module.scss'

interface IChangeShipmentPointButtonProps {
  order: ITableOrder
  onClick: () => void
}

const CHANGEABLE_STATUSES = [
  EOrderStatus.ON_CONFIRMATION,
  EOrderStatus.CONFIRMED_BY_SELLER
]

export const getShipmentProvider = (order: ITableOrder): TPickupPointProvider =>
  order.pvz?.provider ?? order.delivery_info?.provider ?? 'CDEK'

// Курьерскую доставку СДЭКа продавец тоже сдаёт в ПВЗ
export const canChangeShipmentPoint = (order: ITableOrder) =>
  CHANGEABLE_STATUSES.includes(order.status) &&
  (order.receive_method === ERecieveMethod.PVZ ||
    (order.receive_method === ERecieveMethod.COURIER &&
      getShipmentProvider(order) === 'CDEK'))

export const ChangeShipmentPointButton: React.FC<IChangeShipmentPointButtonProps> = ({
  order,
  onClick
}) => {
  if (!canChangeShipmentPoint(order)) return null

  return (
    <span className={styles.buttonLine}>
      <Button size='middle' onClick={onClick}>
        Изменить
      </Button>
    </span>
  )
}
